// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function item_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var icon_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon_url"), null));
  if (icon_url.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
      if (type_.TAG === /* Ok */0) {
        var build_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "build_type"), null));
        if (build_type.TAG === /* Ok */0) {
          var count = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "count"), null));
          if (count.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      icon_url: icon_url._0,
                      name: name._0,
                      type_: type_._0,
                      build_type: build_type._0,
                      count: count._0
                    }
                  };
          }
          var e = count._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".count" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = build_type._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".build_type" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = type_._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".type" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = icon_url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".icon_url" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function service_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var icon_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon_url"), null));
  if (icon_url.TAG === /* Ok */0) {
    var partner_count = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_count"), null));
    if (partner_count.TAG === /* Ok */0) {
      var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
      if (description.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  icon_url: icon_url._0,
                  partner_count: partner_count._0,
                  description: description._0
                }
              };
      }
      var e = description._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".description" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = partner_count._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".partner_count" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = icon_url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".icon_url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function catalog_items_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (type_.TAG === /* Ok */0) {
    var service_info = service_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_info"), null));
    if (service_info.TAG === /* Ok */0) {
      var items = Decco.arrayFromJson(item_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "items"), null));
      if (items.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  type_: type_._0,
                  service_info: service_info._0,
                  items: items._0
                }
              };
      }
      var e = items._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".items" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = service_info._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_info" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function other_items_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
  if (type_.TAG === /* Ok */0) {
    var service_info = service_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_info"), null));
    if (service_info.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                type_: type_._0,
                service_info: service_info._0
              }
            };
    }
    var e = service_info._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_info" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = type_._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".type" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function item_details_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CatalogItems" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = catalog_items_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CatalogItems */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "OtherItems" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = other_items_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OtherItems */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function item_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var load_description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "load_description"), null));
  if (load_description.TAG === /* Ok */0) {
    var item_details = {
      TAG: /* Ok */0,
      _0: Belt_Option.getWithDefault(Js_dict.get(dict$1, "item_details"), null)
    };
    if (item_details.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                load_description: load_description._0,
                item_details: item_details._0
              }
            };
    }
    var e = item_details._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".item_details" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = load_description._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".load_description" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function location_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var location_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location_type"), null));
  if (location_type.TAG === /* Ok */0) {
    var lift_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lift_type"), null));
    if (lift_type.TAG === /* Ok */0) {
      var floor = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "floor"), null));
      if (floor.TAG === /* Ok */0) {
        var labour_requirement = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "labour_requirement"), null));
        if (labour_requirement.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    location_type: location_type._0,
                    lift_type: lift_type._0,
                    floor: floor._0,
                    labour_requirement: labour_requirement._0
                  }
                };
        }
        var e = labour_requirement._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".labour_requirement" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = floor._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".floor" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = lift_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".lift_type" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = location_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".location_type" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_crn = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_crn"), null));
  if (order_crn.TAG === /* Ok */0) {
    var schedule_order_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "schedule_order_id"), null));
    if (schedule_order_id.TAG === /* Ok */0) {
      var requirement_uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "requirement_uuid"), null));
      if (requirement_uuid.TAG === /* Ok */0) {
        var item_info = item_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "item_info"), null));
        if (item_info.TAG === /* Ok */0) {
          var location_info = Decco.arrayFromJson(location_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "location_info"), null));
          if (location_info.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      order_crn: order_crn._0,
                      schedule_order_id: schedule_order_id._0,
                      requirement_uuid: requirement_uuid._0,
                      item_info: item_info._0,
                      location_info: location_info._0
                    }
                  };
          }
          var e = location_info._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".location_info" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = item_info._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".item_info" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = requirement_uuid._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".requirement_uuid" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = schedule_order_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".schedule_order_id" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = order_crn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_crn" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var order_info = Decco.arrayFromJson(order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "order_info"), null));
  if (order_info.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              order_info: order_info._0
            }
          };
  }
  var e = order_info._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_info" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  item_decode ,
  service_info_decode ,
  catalog_items_decode ,
  other_items_decode ,
  item_details_decode ,
  item_info_decode ,
  location_info_decode ,
  order_info_decode ,
  t_decode ,
  
}
/* No side effect */
